import { ArrowRightOutlined } from '@ant-design/icons';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const Container = styled.div``;

export const NotesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FlightEvolutionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  gap: 24px;
`;

export const StagesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ArrowRightIcon = styled(ArrowRightOutlined)`
  color: ${COLOR_OPTIONS.NEUTRAL_100};
  font-size: 12px;
`;
